"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image360Loader = void 0;
const three_1 = require("three");
const utils_1 = require("../utils/utils");
class Image360Loader {
    load(url, loaderManager, tokenProvider) {
        return __awaiter(this, void 0, void 0, function* () {
            const loader = new three_1.TextureLoader(loaderManager);
            if ((0, utils_1.isUrlPrivate)(url)) {
                if (tokenProvider === undefined) {
                    throw new Error("Jwt token calback is not defined");
                }
                const header = { ['Authorization']: 'Bearer ' + tokenProvider() };
                loader.setRequestHeader(header);
            }
            return new Promise((res, rej) => {
                loader.load(url, (texture) => {
                    res(texture);
                }, (xhr) => {
                    // let loading = ((xhr.loaded / xhr.total) * 100).toFixed(2);
                }, (err) => {
                    rej(err);
                });
            });
        });
    }
}
exports.Image360Loader = Image360Loader;
